/** Tracker AI backend base URL (NestJS ai_tracker/v1). */
export const getTrackerAiApiBase = (): string =>
  import.meta.env.VITE_TRACKER_AI_API_URL ?? 'http://localhost:3020/ai_tracker/v1';
